<template>
	<div class="item job-item" :style="style" :class="{ hovered: hover }">
		<v-row >
			<v-col class="marker start shrink" v-if="!item.startOut"
				@mouseover="hover = true"
				@mouseleave="hover = false"
				@click="clicked">
				<v-icon>fas fa-play</v-icon>
			</v-col>
			<v-col class="marker start fade shrink" v-else>
				<v-icon>fas fa-arrow-alt-left</v-icon>
			</v-col>
			<v-col class="job-spacer grow"></v-col>
			<v-col class="marker end shrink" :class="item.status" v-if="item.status !== 'start' && !item.endOut"
				@mouseover="hover = true"
				@mouseleave="hover = false"
				@click="clicked">
				<v-icon v-if="item.status  === 'end'">fas fa-check</v-icon>
				<v-icon v-if="item.status  === 'failed'">fas fa-times</v-icon>
				<v-icon v-if="item.status  === 'processing'">fa-spin fas fa-spinner</v-icon>
				<v-icon v-if="item.status  === 'unknown'">fas fa-question</v-icon>
			</v-col>
			<v-col class="marker end fade shrink" :class="item.status" v-if="item.status !== 'start' && item.endOut">
				<v-icon>fas fa-arrow-alt-right</v-icon>
			</v-col>
		</v-row>
	</div>
</template>

<script>

export default {
	props: {
		item: Object,
	},
	data() {
		return {
			hover: false,
		};
	},
	computed: {
		style() {
			return `left: ${this.item.dqLeft}%; width: ${this.item.jobWidth}%`;
		},
	},
	methods: {
		clicked() {
			this.$emit("click", this.item.id);
		},
	},
};
</script>
